const initState = {
    theme: 'default',
};

const Reducer = (state = initState) => {
    return state;
};

export default Reducer;
